<section class="panel">
  <h2>{{ 'rule.title' | t }}</h2>
  <div class="grid three">
    <label>
      {{ 'rule.productId' | t }}
      <input [(ngModel)]="productId" />
    </label>
    <label>
      {{ 'rule.rulesetName' | t }}
      <input [(ngModel)]="rulesetName" />
    </label>
    <label>
      {{ 'rule.rulesetId' | t }}
      <input [(ngModel)]="rulesetId" />
    </label>
  </div>
  <div class="actions">
    <button type="button" (click)="createRuleSet()" [disabled]="busy">{{ 'rule.createRuleset' | t }}</button>
    <button type="button" (click)="publishRuleSet()" [disabled]="busy">{{ 'rule.publishRuleset' | t }}</button>
  </div>

  <div class="grid four">
    <label>
      {{ 'rule.ruleName' | t }}
      <input [(ngModel)]="ruleName" />
    </label>
    <label>
      {{ 'rule.severity' | t }}
      <select [(ngModel)]="ruleSeverity">
        <option value="ERROR">{{ 'rule.severity.error' | t }}</option>
        <option value="WARN">{{ 'rule.severity.warn' | t }}</option>
      </select>
    </label>
    <label>
      {{ 'rule.leftOption' | t }}
      <input [(ngModel)]="ruleLeftOptionCode" />
    </label>
    <label>
      {{ 'rule.rightOption' | t }}
      <input [(ngModel)]="ruleRightOptionCode" />
    </label>
    <label>
      {{ 'rule.message' | t }}
      <input [(ngModel)]="ruleMessage" />
    </label>
  </div>
  <div class="actions">
    <button type="button" (click)="addRule()" [disabled]="busy">{{ 'rule.addImplies' | t }}</button>
  </div>
</section>

<section class="panel" *ngIf="error">
  <p class="error">{{ error }}</p>
</section>

<section class="panel" *ngIf="info && !error">
  <p class="info">{{ info }}</p>
</section>
